import { combineReducers } from 'redux'
import {
    REQUEST_MEETS,
    RECEIVE_MEETS,
    RECEIVE_1PAGE_MEETS,
    RECEIVE_SINGLE_MEET,
    MEETS_PAGE_COUNT,
    REQUEST_MEETS_TIME,
    RECEIVE_MEETS_TIME,
    REQUEST_VENUES,
    RECEIVE_VENUES,
} from "./actions"

const fetching = (state = null, action = {}) => {
    switch (action.type) {
        case REQUEST_MEETS:
        case REQUEST_MEETS_TIME:
        case REQUEST_VENUES:
            return true
        case RECEIVE_MEETS:
        case RECEIVE_1PAGE_MEETS:
        case RECEIVE_SINGLE_MEET:
        case RECEIVE_MEETS_TIME:
        case RECEIVE_VENUES:
            return false
        default:
            return state
    }
}

const items = (state = null, action = {}) => {
    switch (action.type) {
        case REQUEST_MEETS:
            return state
        case RECEIVE_MEETS:
            if (Array.isArray(action.meets)) {
                const newState = [...state];
                action.meets.forEach(meet => {
                    if (!newState.some(item => item.id === meet.id)) {
                        newState.push(meet);
                        console.log(meet)
                    }
                });
                console.log(newState)
                return newState;
            } else {
                return state
            }
        case RECEIVE_1PAGE_MEETS:
            return action.meets;
        default:
            return state
    }
}

const time = (state = null, action = {}) => {
    switch (action.type) {
        case REQUEST_MEETS_TIME:
            return state
        case RECEIVE_MEETS_TIME:
            if (Array.isArray(action.time)) {
                return action.time
            } else {
                return state
            }
        default:
            return state
    }
}

const venues = (state = null, action = {}) => {
    switch (action.type) {
        case REQUEST_VENUES:
            return state
        case RECEIVE_VENUES:
            if (Array.isArray(action.venues)) {
                return action.venues
            } else {
                return state
            }
        default:
            return state
    }
}

const singleItem = (state = null, action = {}) => {
    switch (action.type) {
        case REQUEST_MEETS:
            return state
        case RECEIVE_SINGLE_MEET:
            return action.meet[0]
        default:
            return state
    }
}

const hasMore = (state = null, action = {}) => {
    switch (action.type) {
        case REQUEST_MEETS:
            return true
        case RECEIVE_MEETS:
        case RECEIVE_1PAGE_MEETS:
            return action.meets.length >= MEETS_PAGE_COUNT;
        default:
            return state

    }
}

export const getMeets = (state) => state.items
export const getSingleMeet= (state) => state.singleItem
export const getMeetsFetching = (state) => state.fetching
export const getMeetsHasMore = (state) => state.hasMore
export const getMeetsTime = (state) => state.time
export const getVenues = (state) => state.venues

const meets = combineReducers({
    items, fetching, hasMore, singleItem, time, venues
})

export default meets;